import { BaseDataService } from '../../../services/base/BaseDataService';
import { HistoryEvent } from '../models/HistoryEvent';

export interface HistoryEventQuery {
    ObjectIds?: number[];
    ObjectTypeIds?: number[];
    EventTypeIds?: number[];
    Includes?: string[];
}

export class HistoryEventService extends BaseDataService<HistoryEvent, HistoryEventQuery> {
    protected prefixUrl: string = 'HistoryEvents';
}
